import axios from "axios";
import { createContext, useContext, useEffect, useState } from "react";

const AuthContext = createContext();

export const useAuth = () => useContext(AuthContext);

// const BASE_URL = "http://localhost:8000";
const BASE_URL = "https://idealpursuits.co.in/api";

export const AuthProvider = ({ children }) => {
  const [userData, setUserData] = useState(() => {
    const storedUserData = localStorage.getItem("userData");
    return storedUserData ? JSON.parse(storedUserData) : null;
  });

  const [liveUserData, setLiveUserData] = useState(null); // Store live user data

  const isLogged = !!userData;

  // Function to fetch live user data
  const fetchLiveUserData = async () => {
    if (!userData?.userId) return; // Ensure userId exists before making a request

    try {
      const response = await axios.post(`${BASE_URL}/getUser.php`, {
        userId: userData.userId,
      });

      if (response.data.success) {
        setLiveUserData(response.data.user);
        return response.data.user;
      }
    } catch (error) {
      console.error("Error fetching live user data:", error);
      return null;
    }
  };

  const login = (data) => {
    setUserData(data);
    localStorage.setItem("userData", JSON.stringify(data));
  };

  const logout = () => {
    setUserData(null);
    setLiveUserData(null);
    localStorage.removeItem("userData");
  };

  useEffect(() => {
    if (!userData) {
      localStorage.removeItem("userData");
    } else {
      fetchLiveUserData(); // Fetch live data when user logs in or changes
    }
  }, [userData]);

  const value = {
    userData,
    liveUserData,
    isLogged,
    login,
    logout,
    fetchLiveUserData,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};
